module.exports = __webpack_public_path__ + "img/undraw_data_reports_706v.023fba9b.svg";